import { Stack } from "@mui/material";
import BadgedAvatar from "../base/BadgedAvatar";
import { assertThumbnailUrl } from "../../redux/common";
import { UserInfo } from "../../redux/user/userSlice";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getOrRetrieveNamedObject, selectObjectCache } from "../../redux/object/objectCacheSlice";
import { useAppDispatch } from "../../app/hooks";
import { ObjectTarget } from "../../app/permissions";

interface TileProps {
    id: number | string;
}

const StudentTile = ({ id }: TileProps) => {
    const objectCache = useSelector(selectObjectCache);
    const dispatch = useAppDispatch();
    const named = getOrRetrieveNamedObject(dispatch, objectCache, ObjectTarget.STUDENT, `${id}`);
    return (
        <Stack direction="column" spacing={0.5} flexWrap="wrap" sx={{my: 1}}>
            <Stack key={"user"} direction="row" alignItems="center">
                <BadgedAvatar
                    title={named?.display || "-"}
                    avatar={assertThumbnailUrl(named?.url)}
                    size="24px"
                    fontSize="12px"
                    marginRight={1}
                />
                {named?.display || "-"}
            </Stack>
        </Stack>
    );
};

export default StudentTile;
